import { createCrudService } from './createCrudService';
import { httpClient } from './api/httpClient';
import { isMockEnabled, mockResponse } from './api/mockAdapter';
import { API_ENDPOINTS } from 'constants/apiEndpoints';
import { ENTITY_STATUS } from 'constants/status';
import { MOCK_CRON_JOBS } from 'mock/cronJobs.mock';

export const toCronJob = (raw) =>
  raw && {
    id: raw.id,
    jobName: raw.job_name ?? raw.jobName ?? '',
    newspaperId: raw.newspaper_id ?? raw.newspaperId ?? '',
    newspaperName: raw.newspaper_name ?? raw.newspaperName ?? '',
    edition: raw.edition,
    source: raw.source,
    sourceDetails: raw.source_details ?? raw.sourceDetails ?? '',
    // Business scheduling fields
    frequency: raw.frequency ?? 'daily',
    time: raw.time ?? '07:00',
    dayOfWeek: raw.day_of_week ?? raw.dayOfWeek ?? null,
    dayOfMonth: raw.day_of_month ?? raw.dayOfMonth ?? null,
    // Generated by backend — read-only
    cronExpression: raw.cron_expression ?? raw.cronExpression ?? '',
    // Runtime state
    lastRunAt: raw.last_run_at ?? raw.lastRunAt ?? null,
    lastRunStatus: raw.last_run_status ?? raw.lastRunStatus ?? 'idle',
    lastError: raw.last_error ?? raw.lastError ?? null,
    nextRunAt: raw.next_run_at ?? raw.nextRunAt ?? null,
    status: raw.status,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
    updatedAt: raw.updated_at ?? raw.updatedAt ?? null,
  };

const toPayload = (model) => {
  const payload = {
    job_name: model.jobName,
    newspaper_id: model.newspaperId,
    newspaper_name: model.newspaperName,
    edition: model.edition,
    source: model.source,
    source_details: model.sourceDetails,
    frequency: model.frequency,
    time: model.time,
    timezone: 'Asia/Kolkata',
    status: model.status,
  };

  if (model.frequency === 'weekly' && model.dayOfWeek) {
    payload.day_of_week = model.dayOfWeek;
  }
  if (model.frequency === 'monthly' && model.dayOfMonth) {
    payload.day_of_month = parseInt(model.dayOfMonth, 10);
  }

  return payload;
};

const base = createCrudService({
  endpoints: API_ENDPOINTS.CRON_JOBS,
  toModel: toCronJob,
  toPayload,
  mockSeed: MOCK_CRON_JOBS,
  idPrefix: 'cron',
});

export const cronJobService = {
  ...base,
  async toggle(id, nextStatus) {
    if (isMockEnabled()) {
      const store = base._getStore();
      base._setStore(store.map((r) => (r.id === id ? { ...r, status: nextStatus } : r)));
      return toCronJob(await mockResponse(base._getStore().find((r) => r.id === id)));
    }
    return toCronJob(await httpClient.patch(API_ENDPOINTS.CRON_JOBS.TOGGLE(id), { status: nextStatus }));
  },
};

export { ENTITY_STATUS };
export default cronJobService;
